export default {
  validate: (data) => {
    const errors = {};

    // Property validation
    if (!data.property?.address?.trim()) {
      errors.address = 'Property address is required';
    }
    if (!data.property?.landlord?.trim()) {
      errors.landlord = 'Landlord name is required';
    }
    if (!data.property?.inspectionDate) {
      errors.inspectionDate = 'Inspection date is required';
    }

    // Engineer validation
    if (!data.engineer?.engineerName?.trim()) {
      errors.engineerName = 'Engineer name is required';
    }
    if (!data.engineer?.electricalRegNumber?.trim()) {
      errors.electricalRegNumber = 'Electrical registration number is required';
    }

    // Circuits validation
    if (!data.circuits || data.circuits.length === 0) {
      errors.circuits = 'At least one circuit must be recorded';
    } else {
      data.circuits.forEach((circuit, index) => {
        if (!circuit.circuitType) {
          errors[`circuit_${index}_circuitType`] = 'Circuit type is required';
        }
        if (!circuit.location?.trim()) {
          errors[`circuit_${index}_location`] = 'Circuit location is required';
        }
        if (!circuit.protectiveDevice) {
          errors[`circuit_${index}_protectiveDevice`] = 'Protective device is required';
        }
        if (!circuit.testResult) {
          errors[`circuit_${index}_testResult`] = 'Test result is required';
        }
      });
    }

    // Certification validation
    if (!data.certification?.nextInspectionDate) {
      errors.nextInspectionDate = 'Next inspection date is required';
    }
    if (!data.certification?.certificateNumber?.trim()) {
      errors.certificateNumber = 'Certificate number is required';
    }

    return {
      isValid: Object.keys(errors).length === 0,
      errors
    };
  }
};